import { STATUS_CODE } from '@kc-console/core';

import { getRequestUrlData } from '../../../utils/getRequestUrlData';

import type { BaseState } from '@kc-console/context';
import type { Guard } from '../../../types';

const CLASSIC_BUCKETS_PATH_PREFIX = '/object-storage/classic-buckets';

/**
 * Object Storage 의 classic-buckets 하위 경로로 라우트 이동 시 무조건 full reload 시키는 가드.
 * @description
 * - baguni Next 의 클라이언트 라우팅을 벗어나기 위해 origin 포함 절대 URL 로 리다이렉트
 * - 라우트 이동 시(`/_next/data/...`)에만 동작하며, 초기 진입 시점에는 이미 풀 페이지 로드 상태이므로 별도 처리하지 않음
 */
export const forceReloadClassicBucketsRouteGuard: Guard<BaseState> = async ({ state, context }) => {
  const { status } = state;
  if (status !== STATUS_CODE.OK) return { status };

  const { urlObj } = getRequestUrlData(context);
  const { pathname, search, origin } = urlObj;

  if (!pathname.startsWith(CLASSIC_BUCKETS_PATH_PREFIX)) return { status };

  return {
    redirect: {
      destination: `${origin}${pathname}${search}`,
      permanent: false,
    },
  };
};

forceReloadClassicBucketsRouteGuard.displayName = 'forceReloadClassicBucketsRouteGuard';
